export default {"src":"/_next/static/media/arrow-down-line.78144aea.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};